import template   from './registration-contacts-block.html'
import controller from './registration-contacts-block.controller'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/registration/common/registration-contacts-block/registration-contacts-block.component.js